var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "remodal modal modal__lineupProduct",
        attrs: { "data-remodal-id": "modal-lineup-" + _vm.item.id },
      },
      [
        _c("button", {
          staticClass: "remodal-close",
          attrs: { "data-remodal-action": "close" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "modal__lineupProduct2col" }, [
          _c("div", { staticClass: "modal__lineupProduct2colimg" }, [
            _c("img", { attrs: { src: _vm.item.img.main, alt: "" } }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal__lineupProduct2colTxt" }, [
            _c("dl", { staticClass: "modal__lineupProduct2colTxtTop" }, [
              _c("dt", [_vm._v(_vm._s(_vm.item.productName))]),
              _vm._v(" "),
              _c("dd", [
                _c("p", [_vm._v(_vm._s(_vm.item.num))]),
                _vm._v(" "),
                _c("table", [
                  _c("tr", [
                    _c("th", [_vm._v("ワイズ")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.item.wise))]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("ヒール")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.item.heels))]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("サイズ")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.item.size))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tr",
                    { staticClass: "modal__lineupProduct2colTxtTop--color" },
                    [
                      _c("th", [_vm._v("カラー")]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "ul",
                          { staticClass: "lineup__colorTip" },
                          _vm._l(_vm.item.color, function (col) {
                            return _c("li", {
                              class:
                                "lineup__colorTipLi lineup__colorTipLi--" + col,
                            })
                          }),
                          0
                        ),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "modal__lineupProductBtnCart btn-ga",
                  attrs: {
                    target: "_blank",
                    "data-name": _vm.item.id,
                    href: _vm.item.url,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.click(_vm.item.id)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("dl", { staticClass: "modal__lineupProduct2colTxtBtm" }, [
              _c("dt", [_vm._v("足長・足囲チャート")]),
              _vm._v(" "),
              _c("dd", [
                _c(
                  "table",
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._l(_vm.item.table, function (t) {
                      return _c("tr", [
                        _c("td", [_vm._v(_vm._s(t[0]))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(t[1]))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(t[2]))]),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("サイズ")]),
      _vm._v(" "),
      _c("th", [_vm._v("足長")]),
      _vm._v(" "),
      _c("th", [_vm._v("足囲")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }